import React from 'react';
import { HomeIcon, SearchIcon } from '../Icons/Icons';
import './CallToAction.css';

function CallToAction() {
  const handleSellClick = () => {
    if (window.navigateTo) {
      window.navigateTo('sell-property');
    }
  };

  const handleBuyClick = () => {
    if (window.navigateTo) {
      window.navigateTo('find-dream-home');
    }
  };

  return (
    <section className="call-to-action">
      <div className="container">
        <div className="cta-grid">
          <div className="cta-card primary">
            <div className="cta-content">
              <h2>Ready to Sell Your Property?</h2>
              <p>List your property with us and reach millions of potential buyers across Pakistan</p>
              <button className="btn-cta" onClick={handleSellClick}>Post Your Property</button>
            </div>
            <div className="cta-icon">
              <HomeIcon size={80} color="rgba(255, 255, 255, 0.5)" />
            </div>
          </div>

          <div className="cta-card secondary">
            <div className="cta-content">
              <h2>Find Your Dream Home</h2>
              <p>Browse thousands of verified properties in your preferred location</p>
              <button className="btn-cta" onClick={handleBuyClick}>Start Searching</button>
            </div>
            <div className="cta-icon">
              <SearchIcon size={80} color="rgba(255, 255, 255, 0.5)" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CallToAction;
